<template>
  <div
    ref="kt_modal_tipo_usuarios_editar"
    data-bs-backdrop="static"
    data-bs-focus="false"
    class="modal fade modal-overlay"
    tabindex="-1"
    id="kt_modal_tipo_usuarios_editar"
  >
    <div
      class="modal-dialog modal-md modal-dialog-centered modal-dialog-scrollable"
    >
      <div class="modal-content">
        <div class="modal-header">
          <h3 class="modal-title" v-if="this.idTipoUsuario === 0">
            <img
              src="media/icons/duotune/general/gen055.svg"
              class="me-2"
            />Adicionar Grupo
          </h3>
          <h3 class="modal-title" v-else>
            <img
              src="media/icons/duotune/general/gen055.svg"
              class="me-2"
            />Editar Grupo
          </h3>
          <div
            class="btn btn-icon btn-sm btn-active-light-primary"
            data-bs-dismiss="modal"
            @click="modalEditarTipoUsuario(false)"
          >
            <span class="svg-icon svg-icon-2x">
              <img src="media/icons/duotune/arrows/arr061.svg" />
            </span>
          </div>
        </div>
        <div class="modal-body p-0">
          <div class="post d-flex flex-column-fluid pt-7 bg-lighten">
            <div class="container-xxl p-0" ref="errosGerais">
              <div
                v-if="loading"
                class="ms-7 mb-7"
                v-bind:data-kt-indicator="loading ? 'on' : 'off'"
              >
                <span class="indicator-progress">
                  Aguarde, carregando...
                  <span
                    class="spinner-border spinner-border-sm align-middle ms-2"
                  ></span>
                </span>
              </div>
              <div
                v-if="this.errosGerais.Message"
                class="notice d-flex bg-light-danger rounded border-danger border border-dashed ms-7 me-7 mb-9 p-6"
              >
                <span class="svg-icon svg-icon-2tx svg-icon-danger me-4">
                  <inline-svg src="media/icons/duotune/general/gen044.svg" />
                </span>
                <div class="d-flex flex-stack flex-grow-1">
                  <div class="fw-bold">
                    <h4 class="text-gray-800 fw-bolder">Aviso</h4>
                    <div class="fs-6 text-gray-600">
                      {{ this.errosGerais.Message }}
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="!loading" class="d-flex flex-column flex-lg-row px-7">
                <div
                  class="d-flex flex-column flex-row-fluid gap-6 mb-7 gap-lg-10"
                >
                  <div class="d-flex flex-column gap-7 gap-lg-10">
                    <div class="card card-flush py-4">
                      <div class="card-header">
                        <div class="card-title">
                          <h2>Geral</h2>
                        </div>
                      </div>
                      <div class="card-body pt-0">
                        <div class="mb-5 fv-row">
                          <label class="required form-label"
                            >Descrição do grupo de usuário</label
                          >
                          <input
                            type="text"
                            class="form-control mb-2"
                            placeholder="Descrição do grupo de usuário"
                            maxlength="75"
                            v-model="tipoUsuario.tipo"
                          />
                          <div class="row">
                            <div class="col-6 pe-0">
                              <div
                                class="fv-plugins-message-container invalid-feedback m-0"
                              >
                                {{ errosValidacao["tipo"] }}
                              </div>
                            </div>
                            <div class="col-6 ps-2">
                              <div class="text-end text-muted fs-7">
                                {{ tipoUsuario.tipo.length }}/75 caracteres
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="mb-10 fv-row">
                          <label class="form-label me-15"
                            >Deseja replicar as restrições?</label
                          >
                          <div class="btn-group w-50">
                            <label
                              class="btn text-muted text-hover-white text-active-white btn-outline btn-active-success"
                              :class="[
                                this.replicarRestricao === true && 'active',
                              ]"
                            >
                              <input
                                class="btn-check"
                                type="radio"
                                @click="replicarRestricao = true"
                              />
                              SIM
                            </label>
                            <label
                              class="btn text-muted text-hover-white text-active-white btn-outline btn-active-success"
                              :class="[
                                this.replicarRestricao === false && 'active',
                              ]"
                            >
                              <input
                                class="btn-check"
                                type="radio"
                                @click="replicarRestricao = false"
                              />
                              NÃO
                            </label>
                          </div>
                        </div>
                        <div
                          v-if="this.replicarRestricao === true"
                          class="mb-5 fv-row"
                        >
                          <label class="form-label">Grupo de usuários</label>
                          <select
                            class="form-select"
                            v-model="idReplicarRestricao"
                          >
                            <option
                              v-for="tipo in tipoUsuarios"
                              v-bind:key="tipo.id"
                              v-bind:value="tipo.id"
                            >
                              {{ tipo.tipo }}
                            </option>
                          </select>
                          <div class="text-end text-muted fs-7">
                            Selecione o grupo de usuário que deseja replicar
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card-footer d-flex justify-content-end py-6 px-9">
                <button
                  class="btn btn-danger svg-icon-white me-2 mb-2"
                  data-bs-dismiss="modal"
                  @click="modalEditarTipoUsuario(false)"
                >
                  <span class="svg-icon svg-icon-1">
                    <inline-svg
                      src="media/icons/duotune/arrows/arr015.svg"
                      class="me-2"
                    />Cancelar
                  </span>
                </button>
                <button
                  class="btn btn-success svg-icon-white mb-2"
                  @click="confirmarTipoUsuario()"
                  v-bind:data-kt-indicator="this.loading ? 'on' : 'off'"
                >
                  <span class="indicator-progress">
                    <span
                      class="spinner-border spinner-border-sm align-middle ms-1"
                    ></span>
                    Aguarde...
                  </span>
                  <span class="svg-icon svg-icon-1" v-if="!this.loading">
                    <inline-svg
                      src="media/icons/duotune/arrows/arr016.svg"
                      class="me-2"
                    />Confirmar
                  </span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { hideModal, getOrCreateInstanceModal } from "@/core/helpers/dom";
import { useToast } from "vue-toastification";
const toast = useToast();

export default {
  emits: ["exibirModalTipoUsuario", "atualizarTipoUsuario"],
  components: {},
  props: {
    idTipoUsuario: { type: Number, required: true },
  },
  methods: {
    modalEditarTipoUsuario(exibir) {
      if (exibir === false) {
        this.$emit("exibirModalTipoUsuario", false);
      }
    },
    async confirmarTipoUsuario() {
      this.errosGerais = {};
      this.errosValidacao = [];
      this.loading = true;

      if (this.tipoUsuario.id === 0) {
        try {
          var ret = await this.$store.dispatch(
            "tipoUsuario/postTipoUsuario",
            this.tipoUsuario
          );
          if (ret.Success === true) {
            this.tipoUsuario.id = ret.Data.id;
            toast.success("Grupo cadastrado com sucesso!", { timeout: 3000 });
            await this.replicarRestricoes();
          }
        } catch (error) {
          this.errosGerais = error;
          this.errosValidacao = error;
        }
      } else {
        try {
          var retPut = await this.$store.dispatch(
            "tipoUsuario/putTipoUsuario",
            this.tipoUsuario
          );
          if (retPut.Success === true) {
            toast.success("Grupo atualizado com sucesso!", { timeout: 3000 });
            await this.replicarRestricoes();
          }
        } catch (error) {
          this.errosGerais = error;
          this.errosValidacao = error;
        }
      }
      if (this.errosGerais.Message) {
        this.scroll("errosGerais");
      }

      this.loading = false;
    },
    async replicarRestricoes() {
      if (this.replicarRestricao === true) {
        if (this.add === false) {
          await this.verificarRestricoes();
        }
        try {
          var retOdata = await this.$store.dispatch(
            "restricao/getRestricaoOData",
            "?$select=permissao,modulo,descricao,regra,id_tipo_usuario&$orderby=modulo asc" +
              "&$filter=id_tipo_usuario eq " +
              this.idReplicarRestricao
          );
          if (retOdata.value !== null && retOdata.value.length > 0) {
            var restricaoGrupo = retOdata.value;

            for (var i = 0; i < restricaoGrupo.length; i++) {
              await this.inserirRestricoes(restricaoGrupo[i]);
            }
          }
          toast.success("Restrições replicadas com sucesso!", {
            timeout: 3000,
          });
        } catch (error) {
          this.errosGerais = error;
        }
      }
      this.$emit("atualizarTipoUsuario");
      this.modalEditarTipoUsuario(false);
      hideModal(this.$refs.kt_modal_tipo_usuarios_editar);
    },
    async inserirRestricoes(restricao) {
      try {
        restricao.id_tipo_usuario = this.tipoUsuario.id;
        await this.$store.dispatch("restricao/postRestricao", restricao);
      } catch (error) {
        this.errosGerais = error;
      }
    },
    async verificarRestricoes() {
      try {
        var retOdata = await this.$store.dispatch(
          "restricao/getRestricaoOData",
          "?$select=id,permissao,modulo,descricao,regra,id_tipo_usuario&$orderby=modulo asc" +
            "&$filter=id_tipo_usuario eq " +
            this.tipoUsuario.id
        );
        if (retOdata.value !== null && retOdata.value.length > 0) {
          var restricaoGrupo = retOdata.value;

          for (var i = 0; i < restricaoGrupo.length; i++) {
            await this.deletarRestricoes(restricaoGrupo[i].id);
          }
        }
      } catch (error) {
        this.errosGerais = error;
      }
    },
    async deletarRestricoes(id) {
      try {
        await this.$store.dispatch("restricao/deleteRestricao", id);
      } catch (error) {
        this.errosGerais = error;
      }
    },
    limparTipoUsuario() {
      this.tipoUsuario = {
        id: 0,
        tipo: "",
        guid: "",
      };

      this.tipoUsuario.guid = this.$utils.generateUuidv4();
      this.errosGerais = {};
      this.errosValidacao = [];
    },
    scroll(refName) {
      let el = this.$refs[refName];
      if (el) {
        el.scrollIntoView({
          behavior: "smooth",
          block: "center",
          inline: "center",
        });
      }
    },
    async carregarTipoUsuario() {
      this.errosGerais = {};
      this.errosValidacao = [];
      try {
        var ret = await this.$store.dispatch(
          "tipoUsuario/getTipoUsuario",
          this.idTipoUsuario
        );
        if (ret.Data !== null) {
          this.tipoUsuario = ret.Data;
        } else {
          this.errosGerais = ret;
        }
      } catch (error) {
        this.errosGerais = error;
      }
      if (this.errosGerais.Message) {
        this.scroll("errosGerais");
      }
      this.loading = false;
    },
    async carregarTipoUsuarios() {
      try {
        var retOdata = await this.$store.dispatch(
          "tipoUsuario/getTipoUsuarioOData",
          "?$select=id,tipo&$orderby=tipo asc"
        );
        if (retOdata.value !== null && retOdata.value.length > 0) {
          this.tipoUsuarios = retOdata.value;
          this.idReplicarRestricao = this.tipoUsuarios[0].id;
        } else {
          this.tipoUsuarios = [];
        }
      } catch (error) {
        this.errosGerais = error;
      }
    },
    async asyncData() {
      this.tipoUsuarios = [];
      this.idReplicarRestricao = 0;
      this.replicarRestricao = false;
      if (this.idTipoUsuario !== 0) {
        this.loading = true;
        this.add = false;
        await this.carregarTipoUsuario();
      } else {
        this.add = true;
        this.limparTipoUsuario();
      }
      await this.carregarTipoUsuarios();
    },
  },
  mounted() {
    this.asyncData();
  },
  data() {
    return {
      loading: false,
      add: false,
      errosGerais: {},
      errosValidacao: [],
      tipoUsuario: {
        id: 0,
        tipo: "",
        guid: "",
      },
      tipoUsuarios: [],
      idReplicarRestricao: 0,
      replicarRestricao: false,
    };
  },
};
</script>

<style></style>
